import gql from 'graphql-tag';

export const byDokkioLabelNameCountFragment = gql`
  fragment byDokkioLabelNameCountFragment on ByDokkioLabelNameCount {
    dokkioLabelName
    count
  }
`;
export default byDokkioLabelNameCountFragment;
